import type { ChangePasswordRequest, TenantAdminCreateRequest } from '@/shared/api/types/user-types'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  changeTenantAdminPassword,
  createTenantAdmin,
  getTenantAdmins,
} from '@/shared/api/services/tenant-admin-service'

export const TENANT_ADMIN_QUERY_KEYS = {
  all: ['tenant-admins'] as const,
  list: (tenantId: string) => [...TENANT_ADMIN_QUERY_KEYS.all, 'list', tenantId] as const,
}

export function useTenantAdminsQuery(tenantId: string) {
  return useQuery({
    queryKey: TENANT_ADMIN_QUERY_KEYS.list(tenantId),
    queryFn: async () => getTenantAdmins(tenantId),
    enabled: !!tenantId,
  })
}

export function useCreateTenantAdminMutation(tenantId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: TenantAdminCreateRequest) => createTenantAdmin(tenantId, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TENANT_ADMIN_QUERY_KEYS.list(tenantId) })
    },
  })
}

export function useChangeTenantAdminPasswordMutation(tenantId: string) {
  return useMutation({
    mutationFn: async ({ adminId, payload }: { adminId: string; payload: ChangePasswordRequest }) =>
      changeTenantAdminPassword(tenantId, adminId, payload),
  })
}
